import { Alpha2CountryCode } from '@common/types/common';
import { Roles } from '@common/types/user';
import { APP_PREFIX_PATH } from '@constants/common';
import { useAppDispatch } from '@hooks/generic';
import { useAuth } from '@hooks/useAuth';
import { setError } from '@store/errorSlice';
import { toLogin } from '@utils/route';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

type ProtectedRoutesProps = {
    countries?: Alpha2CountryCode[];
};

const ProtectedRoutes = ({ countries }: ProtectedRoutesProps) => {
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();

    const { isUserLoading, error, user } = useAuth();
    if (isUserLoading) {
        return 'Loading ...';
    } else if (error) {
        if (pathname.replace(/\/+$/, '') === APP_PREFIX_PATH) {
            return <Navigate to={toLogin()} replace />;
        }

        dispatch(setError({ status: 401 }));
    } else if (
        countries &&
        user &&
        !countries.includes(user?.country_id as Alpha2CountryCode) &&
        user.role !== Roles.VICTRON
    ) {
        dispatch(setError({ status: 403 }));
    } else {
        return <Outlet />;
    }
};

export { ProtectedRoutes };
